import {
    Container,
    Content,
    Header,
    LegendColor,
    LegendInfo,
    LegendItem,
    LegendLabel,
    Title,
} from "./styles";
import useMapData from "ui/pages/app/planejamentoOperacional/hooks/useMapData";
import useRelatorioContext from "ui/pages/app/planejamentoOperacional/hooks/useRelatorioContext";

type LegendVariant = "green" | "yellow" | "gray" | "blue";

export function GestaoOS() {
    const sidebarMenuOpen = useMapData((s) => s.sidebarMenuOpen);
    const { showLegendsRelatorio } = useRelatorioContext();

    const LEGEND_ITEMS: { variant: LegendVariant; label: string }[] = [
        {
            variant: "green",
            label: "Vinculado (com plano)",
        },
        {
            variant: "yellow",
            label: "Vinculado (sem plano)",
        },
        {
            variant: "gray",
            label: "Disponível — Clique para selecionar",
        },
        {
            variant: "blue",
            label: "Selecionado — botão direito → Criar O.S.",
        },
    ];

    if (!showLegendsRelatorio) return null;

    return (
        <Container $isOpenMenu={sidebarMenuOpen}>
            <Header>
                <Title>
                    Legenda — Nova O.S.
                </Title>
            </Header>

            <Content>
                {LEGEND_ITEMS.map((item) => (
                    <LegendItem key={item.label}>
                        <LegendColor $variant={item.variant} />
                        <LegendInfo>
                            <LegendLabel>{item.label}</LegendLabel>
                        </LegendInfo>
                    </LegendItem>
                ))}
            </Content>
        </Container>
    );
}
